export enum AnalyticsEmail {
    BoletoFatura = "Boleto/Fatura",
    Canhoto = "Canhoto",
    CTeXML = "XML CTe",
    CTePDF = "PDF CTe",
    RPS = "RPS",
    Zip = "Zip"
}